import { init as initConfig, setup as setupConfig } from '@cian/config/browser';
import { UNIQUE_CONFIG_KEY } from '../shared/constants/config';
import { runApp } from './runApp';

setupConfig({ settingsKey: UNIQUE_CONFIG_KEY });
const config = initConfig();

runApp(config);

// tslint:disable-next-line:no-any
if ((module as any).hot) {
  // tslint:disable-next-line:no-any
  (module as any).hot.accept();
}
